// extracted by mini-css-extract-plugin
export default {"dropdown_items_wrapper":"RecentSection_dropdown_items_wrapper__fjY08","show":"RecentSection_show__fvVP4"};